<template>
  <PaymentCheckoutLegalFooter
    :model-value="props.termsAccepted"
    :show-validation-error="props.showTermsError"
    :information-items="informationItems"
    purchase-kind="credit_package"
    @update:model-value="emits('update:termsAccepted', $event)"
  >
    <template #actions>
      <div class="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
        <el-button
          class="!m-0 w-full sm:w-auto"
          @click="onDecline"
        >
          {{ $t("COMMON.CANCEL") }}
        </el-button>

        <el-button
          class="!m-0 w-full sm:w-auto"
          type="primary"
          :disabled="props.disableConfirm"
          :loading="props.loading"
          @click="onConfirm"
        >
          {{ $t("MY_CREDITS_USAGE.PAY_NOW") }}
        </el-button>
      </div>
    </template>
  </PaymentCheckoutLegalFooter>
</template>

<script setup lang="ts">
import PaymentCheckoutLegalFooter from "~/components/payment-checkout/PaymentCheckoutLegalFooter.vue";

type PropsType = {
  disableConfirm: boolean;
  loading: boolean;
  scope: "personal" | "organization";
  termsAccepted: boolean;
  showTermsError: boolean;
};

const props = defineProps<PropsType>();
const emits = defineEmits(["decline", "confirm", "update:termsAccepted"]);

const {$t} = useNuxtApp();
const informationItems = computed(() => props.scope === "organization"
  ? [
      {
        icon: "clock" as const,
        title: $t("TENANT_ADMIN.USAGE.CREDIT_VALIDITY_TITLE"),
        text: $t("TENANT_ADMIN.USAGE.CREDIT_VALIDITY_NOTICE"),
      },
      {
        icon: "qr" as const,
        title: $t("TENANT_ADMIN.USAGE.ADDON_QR_PAYMENT_TITLE"),
        text: $t("TENANT_ADMIN.USAGE.ADDON_PAYMENT_QR_NOTICE"),
      },
    ]
  : [
      {
        icon: "clock" as const,
        title: $t("MY_CREDITS_USAGE.CREDIT_VALIDITY_TITLE"),
        text: $t("MY_CREDITS_USAGE.CREDIT_VALIDITY_NOTICE"),
      },
      {
        icon: "qr" as const,
        title: $t("MY_CREDITS_USAGE.QR_PAYMENT_TITLE"),
        text: $t("MY_CREDITS_USAGE.PAYMENT_QR_NOTICE"),
      },
    ]);

function onDecline() {
  emits("decline");
}

function onConfirm() {
  emits("confirm");
}
</script>
